import React, { ComponentProps } from 'react'
import BasePriceRowPrice from './BasePriceRowPrice'

interface Props extends Pick<ComponentProps<typeof BasePriceRowPrice>, 'data-testid' | 'discountPercentage' | 'discountType' | 'price' | 'saleUnit' | 'signDisplay' | 'size'> {
  /**
   * Leading text
   * @example From $999.99
   */
  caption: string
}

/**
 * Displays a formatted price with a leading caption and a trailing sale unit.
 */
function PriceRowPriceWithCaption(props: Props) {
  return <BasePriceRowPrice {...props} />
}

export default PriceRowPriceWithCaption
